import CenterList from '../../components/admin/CenterList'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'
import { useLocation } from 'react-router-dom'

const Centers = () => {
  return (
    <AdminLayout>
      <AdminContentLayout children={<CenterList />} />
    </AdminLayout>
  )
}

export default Centers
